import React from "react"; 
import { getLoggedInUserGUID, getTimeZoneID, getTimeZoneText, GetAssessmentName } from '../../../../src/web/components/utils';
import './Loader.scss';
interface RouteProps {
    loaderText : string;
 };

const Loader: React.FC<RouteProps> = React.memo(({loaderText}): JSX.Element => {
    return (
        <div className="loader-container">
            <span className="loader"></span>
            {loaderText && <span className="loader-text">{loaderText}</span>}
        </div>
    );
});

export default Loader;